import React from 'react';
import Web3 from 'web3';

class ClaimPrizes extends React.Component {
    state = {
        tokenContract: null,
        contract: null,
        gameStarted: 0,
        isWinner: false,
        winnersList: [],
        downloadLink: '',
        hasFetchedWinners: false,
        hasBurned: false,
        isLoading: true,
        burnAmount: 888888,
    };

    handleBurnClick = async () => {
        const { tokenContract } = this.state;
        const { account } = this.props;
        const burnAmount = Web3.utils.toWei('888888', 'ether');
        try {
            console.log('Burning tokens...');
            // Call the contract method to burn tokens
            await tokenContract.methods.burn(burnAmount).send({ from: account });
            console.log('Tokens burned');
            this.setState({ hasBurned: true });
        } catch (err) {
            console.error(err);
        }
    }
       

    componentDidMount = async () => {
        await this.initializeBlockchainData();
        
        this.intervalId = setInterval(this.initializeBlockchainData, 5000); // Refresh every 10 seconds
    }

    componentWillUnmount() {
        clearInterval(this.intervalId); // Clear the interval when the component unmounts
    }

    initializeBlockchainData = async () => {
    const { web3 } = this.props;
    if (!web3) {
            console.error("Web3 is not available. Please connect your wallet or install a Dapp browser.");
            return;  // Return early if web3 is not available
        }
    
    // setup the contract
    const gameContractAddress = '0x2bdDD797FB8dFEfFcf3363481D8f2d861535549c';//'0x2bdDD797FB8dFEfFcf3363481D8f2d861535549c';
    const gameContractABI = require('./contractABI.json');
    const contract = new web3.eth.Contract(gameContractABI, gameContractAddress);
    
    const tokenContractAddress = '0xed5e50bcE863f390Ff55a4bF6F2D5069d17AC5C0';
    const tokenContractABI = [
      {
        "constant": false,
        "inputs": [
          {
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "burn",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
      }
    ];

    const tokenContract = new web3.eth.Contract(tokenContractABI, tokenContractAddress);

    this.setState({ contract, tokenContract});

    const gameStarted = await contract.methods.gameStarted().call();
    
    this.setState({ gameStarted, isLoading: false }, () => {
        const { hasFetchedWinners, gameStarted } = this.state;
        console.log('hasFetchedWinners:', hasFetchedWinners);
        console.log('gameStarted:', gameStarted);
        console.log(this.props.account);
        // Generate winner list if game ended
        if (!hasFetchedWinners && gameStarted == 2 && this.props.account) {
            console.log('Going to fetch winners...');
            this.fetchWinnersList();
        }

        if (gameStarted == 0 || gameStarted == 1) {
          console.log('fetch false');
            this.setState({ hasFetchedWinners: false });
        }
    });
}


    fetchWinnersList = async () => {
      this.setState({ isLoading: true });

        const { contract } = this.state;
        const { account } = this.props;
        const winnerListLength = await contract.methods.getWinnerListLength().call();
        console.log(winnerListLength);
        let winnersList = [];
        for (let i = 0; i < winnerListLength; i++) {
            winnersList.push(await contract.methods.winnerList(i).call());
            console.log(winnersList);
        }

        // Saving to a Blob
        const gameRound = await contract.methods.gameRound().call();
        console.log('gameround: ', gameRound);

        const data = `Winners:\n${winnersList.join('\n')}`;
        console.log("data:", data);
        const blob = new Blob([data], { type: 'text/plain' });
        const downloadLink = URL.createObjectURL(blob);

        // Check if account is a winner

        const isWinner = await contract.methods.winnerCheck(account).call();
        this.setState({ isWinner, winnersList, downloadLink, hasFetchedWinners: true, isLoading: false });
        console.log('isWinner:', this.state.isWinner);
        console.log('winnersList:', this.state.winnersList);
        console.log('downloadLink:', this.state.downloadLink);
        console.log('hasFetchedWinners:', this.state.hasFetchedWinners);

    }

    claimPrizes = async () => {
        const { contract } = this.state;
        const { account } = this.props;
        try {
            console.log('Sending transaction');
           // await contract.methods.claimPrizes(account).send({ from: account });
            console.log('Transaction sent');
        } catch (err) {
            console.error(err);
        }
    }

  


    
    // ...
    render() {
        const { gameStarted, isWinner, downloadLink, hasBurned, isLoading, burnAmount } = this.state;
        const { account } = this.props;
        if (gameStarted !== '2') return null;
        if (isLoading) {
            return null;
        }
        if (!account) {
            return (
                <div className="enterBox" style={{ backgroundColor: 'red', color: 'white',width: 'auto', height: 'auto', fontSize: '2vw', padding:"1vw",fontWeight: 'bold' }}>
                    Please connect your wallet to check if you won
                </div>
            );
        }

        if (!isLoading && !isWinner && account) {
          return (
         
              <div className="enterBox" style={{ color: 'black', width: 'auto', height: 'auto', fontSize: '2vw', padding: '1vw', fontWeight: 'bold' }}>
                Sorry! You did not win. <br />
                <a href={downloadLink} download="winnerList.txt" style={{ fontSize: '1vw', color: 'black' }}>
                  LIST OF WINNERS
                </a>
                </div>
           
          );
        }


        return (
        <>
    <div className="enterBox" style={{ position: 'relative', padding: '20px',height: 'auto', width: 'auto'}}>
        <div style={{ textAlign: 'center', marginTop: '10px', marginBottom: '40px' }}>
            {gameStarted === '2'&& isWinner  && (
                <>
                    <h2 style={{ fontSize: '2vw', fontWeight: 'bold' }}>
                        You won! Burn {this.state.burnAmount} $EGG to <br /> receive the prizes through airdrop!
                    </h2>
                    <button
                        onClick={this.handleBurnClick}
                        disabled={hasBurned}
                        style={{
                        display: 'block',
                        color: 'white',
                        backgroundColor: hasBurned ? '#aaaaaa' : '#f27e02',
                        marginTop: '20px',
                        marginBottom: '20px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        width: '75%',
                        height: '75%',
                        fontSize: '2vw',
                        fontWeight: 'bold',
                        position: 'relative',
                        border: '1px',
                        boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                        borderRadius: '80px', // round the corners a bit for a better 3D effect
                        transition: 'all 0.5s ease', // transition effect for the button when pressed
                        }}
                        onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                        onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                        onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
                    >BURN</button>
                </>
            )}
            {gameStarted === '2' && isWinner   && (
                <button
                  onClick={() => {
                 window.open('https://twitter.com/intent/tweet?text=I+just+won+a+prize+through+the+EGGROLL+game+by+%40eggmancoin.+Don%27t+miss+out+on+their+next+round%21+Visit+www.eggroll.eggmancoin.com+to+play%21%0D%0A%0D%0A%23EGGMAN+%23EGGPOT+%23ETH+%23MEMECOIN+', '_blank');
                 }}
                  style={{
                    display: 'block',
                    color: 'white',
                    backgroundColor: '#00acee',
                    margin: 'auto',
                    width: '75%',
                    height: '100%',
                    fontSize: '2vw',
                    fontWeight: 'bold',
                    position: 'relative',
                    border: '1px',
                    boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                    borderRadius: '80px', // round the corners a bit for a better 3D effect
                    transition: 'all 0.5s ease', // transition effect for the button when pressed
                  }}
                  onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                  onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                  onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
                >
                  TWEET
                </button>
            )}
            {gameStarted === '9' && isWinner && (
                <button
                    onClick={this.claimPrizes}
                    disabled={!hasBurned}
                    style={{
                        display: 'block',
                        color: 'white',
                        backgroundColor: !hasBurned ? '#aaaaaa' :'#4caf50',
                        marginTop: '20px',
                        marginBottom: '20px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        width: '75%',
                        height: '75%',
                        fontSize: '2vw',
                        fontWeight: 'bold',
                        position: 'relative',
                        border: '1px',
                        boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                        borderRadius: '80px', // round the corners a bit for a better 3D effect
                        transition: 'all 0.5s ease', // transition effect for the button when pressed
                    }}
                    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                    onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                    onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
                >CLAIM</button>
            )}

        </div>
    </div>
    <div className="enterBox" style={{ color: 'black', width: 'auto', height: 'auto', }}>
                <a href={downloadLink} download="winnerList.txt" style={{ fontSize: '2vw', color: 'black' }}>
                  LIST OF WINNERS
                </a>
                </div>
                </>
        );

    }
}

export default ClaimPrizes;